export function isSnowServiceTypeId(value: string): boolean {
    return value === '574f3248c8b8b8c05f8b4ceb';
}
export function isLandscapeServiceTypeId(value: string): boolean {
    return value === '574f2c0ec8b8b8e1648b4bb6';
}
